import Pusher from 'pusher-js'

function getInitState() {
  return {
    pusher: null,
    channel: null
  }
}

export default {
  namespaced: true,
  state: getInitState(),
  mutations: {
    setProperty(state, [key, value]) {
      if (!state.hasOwnProperty(key)) return

      state[key] = value
    }
  },
  actions: {
    createPusher({state, rootState, commit}) {
      if (state.pusher) return
      const token = rootState.user.token
      //https://api.jobian.com/notifies/test/{token}

      const pusher = new Pusher(`a9acdda0e95ffe1e499a`, {
        cluster: 'eu',
        forceTLS: true,
      })

      const channel = pusher.subscribe(`jobian-channel_${token}`)

      commit('setProperty', ['pusher', pusher])
      commit('setProperty', ['channel', channel])
    },
    unbindAll({state, commit}) {
      if(!state.channel) return
      state.channel.unbind();
      commit('setProperty', ['pusher', null])
      commit('setProperty', ['channel', null])
    }
  }
}